<div class="price-container">
  <div class="flex-col-start">
    <section>
      @if (isBulkPrice) {
        <span class="price-scale">{{
          'cartridge.bulkPrice.scale' | transloco
        }}</span>
      }
      <div class="display-price">
        @if (currencySymbolPosition === 'LEADING') {
          <span class="display-price-currency">{{ displayPriceCurrency }}</span>
          <span>{{ displayPrice }}</span>
        } @else {
          <span>{{ displayPrice }}</span>
          <span class="display-price-currency trailing-symbol">{{
            displayPriceCurrency
          }}</span>
        }
      </div>
      @if (isBulkPrice) {
        <span class="price-unit"> / {{ displayServicePackageName }}</span>
      }
    </section>
    @if (!isBulkPrice) {
      <div class="vat markant-caption">
        {{ 'cartridge.priceExcludingVAT' | transloco }}
      </div>
    }
  </div>

  @if (!isBulkPrice && !compact) {
    <markant-platform-price-metadata [price]="price" />
  }
</div>

@if (isBulkPrice) {
  <div class="flex-spaced-between align-items-baseline">
    <div class="vat markant-caption">
      {{ 'cartridge.priceExcludingVAT' | transloco }}
    </div>
    @if (!compact) {
      <markant-platform-price-metadata [price]="price" />
    }
  </div>
}
